import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  expandedCircleGroup: {
    justifyContent: 'center',
  },
  expandCircle: {
    width: 3,
    height: 3,
    marginRight: 3,
    borderRadius: '50%',
    '&:last-child': {
      marginRight: 0,
    },
  },
  orangeCircle: {
    backgroundColor: theme.colors.orange.orange,
  },
  grayCircle: {
    backgroundColor: theme.colors.light.lightCyan,
  },
}));
